module.exports = __webpack_public_path__ + "static/media/empty-pool-white.72f273cc.svg";